import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { getSubscriptionsAll } from '@sxm-de/dev-kits/web-sdk/domains/subscriptions-core';

export type IdentityHasActiveSubscriptionsFn = () => Promise<boolean>;

export function initIdentityHasActiveSubscriptionsFn({
    dependencies,
}: DomainInitPayload): IdentityHasActiveSubscriptionsFn {
    return async () => {
        try {
            const subscriptionsAll = await getSubscriptionsAll(dependencies);

            /**
             *                  === Note! ===
             * For now, we will exclude any SMS subs at this layer.
             * When we are ready to display SMS subs in the account center
             * we will need to remove this filter.
             */
            const subscriptions = subscriptionsAll.filter(
                (subscription) => !('sms' in subscription.source),
            );

            return subscriptions.some((subscription) =>
                ['active', 'pending_cancellation'].some(
                    (state) =>
                        state.toLowerCase() ===
                        subscription.state.toLowerCase(),
                ),
            );
            // TODO: add analytics for subscriptions found
        } catch (error: any) {
            /**
             * TODO:
             * Log error to error logger (not analytics).
             */
            throw new Error('SYSTEM');
        }
    };
}
